import { IDataStatus } from 'interfaces';

export class DataStatus implements IDataStatus {
  constructor(
    public readonly create: boolean = false,
    public readonly del: boolean = false,
    public readonly edit: boolean = false
  ) {}
}
